import { OnboardingStep } from './data/onboardingSteps.ts'
import { ProfileSections } from './data/profile.ts'
import { SubscriptionSections } from './data/subscriptions.ts'
export const isWebDomain = Boolean('')

//export const isNoDemoDomain = import.meta.env.VITE_APP_DOMAIN == 'web'
export const isNoDemoDomain = true
export const TG_BOT_ID = import.meta.env.VITE_TG_BOT_ID as string

export function getQueryParam(
  param: string,
  location: Location = window.location,
): string | null {
  const searchParams = new URLSearchParams(location.search)
  const hashParams = new URLSearchParams(location.hash.slice(1))
  return hashParams.get(param) ?? searchParams.get(param) ?? null
}

export const urls = {
  index: '/',
  learningProfile(rest?: string) {
    return rest ? `/learning-profile/${rest}` : '/learning-profile'
  },
  progress: '/progress',
  contacts: '/contacts',
  lesson(tag: string, rest?: string) {
    const prefix = `/lesson/${tag}`
    return rest ? `${prefix}/${rest}` : prefix
  },
  vocabLesson(tag: string, rest?: string) {
    const prefix = `/vocabulary/${tag}`
    return rest ? `${prefix}/${rest}` : prefix
  },
  login: '/login',
  passwordRecovery: '/passwordRecovery',
  registration: '/registration',
  selectNativeLang: '/select-native-lang',
  payment(
    status: 'success' | 'error' | ':status',
    plan: '1m' | '3m' | '12m' | ':plan?',
  ) {
    return `/payment/${status}/${plan}`
  },
  onboarding(step?: OnboardingStep | ':step?') {
    return step ? `/onboarding/${step}` : '/onboarding'
  },
  trialInfo: '/trial-info',
  subscriptions(section?: SubscriptionSections) {
    return section ? `/subscriptions/${section}` : '/subscriptions'
  },
  subscriptions_kz: '/subscriptions_kz',
  confirm: '/confirm',
  chooseyourlevel: '/choose-your-level',
  demo(infoBlock?: string) {
    return infoBlock ? `/demo/${infoBlock}` : '/demo'
  },
  profile(section?: ProfileSections) {
    return section ? `/profile/${section}` : '/profile'
  },

  program: '/',
  practice: '/practice',
  practiceWords(section?: 'select', programTag?: string) {
    return section && programTag
      ? `/practice/words/${section}/${programTag}`
      : '/practice/words'
  },
  liveSession: '/live-session',
  speaking: '/speaking',
  speakingCompleted: '/speaking-completed',
  myCourses: '/my-courses',
  testMode: '/testing',
  userTest(tag: string, rest?: string) {
    const prefix = `/user-test/${tag}`
    return rest ? `${prefix}/${rest}` : prefix
  },
}
